import axios from 'axios'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../Context/AuthProvider'
import { useState } from 'react'
import moment from 'moment'
import { url } from '../../Constant'
import { checkPermissions, checkIndividualPermission } from '../../Utils/PermissionFunctions'

const TopAgents = () => {
    const { auth } = useAuth();
    const [STARTDATE, setSTARTDATE] = useState(
      ''
    );
    const [ENDDATE, setENDDATE] = useState(
      ''
    );
  
    const [extensionNumber, setExtensionNumber] = useState("");
    const [loader, setLoader] = useState(false);
    const [topAgent, setTopAgent] = useState({
        inbound: null,
        outbound: null,
    });
    const [isSearched, setIsSearched] = useState(false);
    const [extensionList, setExtensionList] = useState([]);

    // Get extensions list
    const getExtensions = () => {


      
      if (auth.role === "2") {
        axios
          .post(
            url + "get-all-extensions",
            {
              vpbx_id: auth.vpbx_id,
            },
            {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }
          )
          .then(
            (response) => {
              if (response.status === 200) {
                if (response.data.message === "Data Found") {
                  setExtensionList(response.data.data);
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else if (auth.role === "3") {
        axios
          .post(
            url + "user-get-all-extensions",
            {
              vpbx_id: auth.vpbx_id,
            },
            {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }
          )
          .then(
            (response) => {
              if (response.status === 200) {
                if (response.data.message === "Data Found") {
                  setExtensionList(response.data.data);
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    };

    const TopAgentfetchData = (endpoint) => {
        setLoader(true);
        axios
          .post(
            endpoint,
            {
              vpbx_id: auth.vpbx_id,
              start_date: STARTDATE,
              end_date: ENDDATE,
              extension_number: extensionNumber,
            },
            {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }
          )
          .then(
            (response) => {
              if (
                response.status === 200 &&
                response.data.message === "Data Found"
              ) {
                let inboundData = [];
                let outboundData = [];
                response.data.data.forEach((val) => {
                  inboundData.push(val.inbound);
                  outboundData.push(val.outbound);
                });
                setTopAgent({
                  inbound: inboundData,
                  outbound: outboundData,
                });
                setLoader(false);
              } else {
                setLoader(false);
              }
            },
            (error) => {
              setLoader(false);
              console.log(error);
            }
          );
      };
    
    // Define getTopAgent function based on role and vpbx_id
    let getTopAgent;
    if (auth.role === "2") {
      if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        getTopAgent = () => TopAgentfetchData(url + "postex-top-agents");
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        getTopAgent = () => TopAgentfetchData(url + "leopard-top-agents");
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        getTopAgent = () => TopAgentfetchData(url + "tcs-top-agents");
      } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
        getTopAgent = () => TopAgentfetchData(url + "travel-channel-topAgent");
      } else {
        getTopAgent = () => TopAgentfetchData(url + "company_vpbx_top_agent");
      }
    } else if (auth.role === "3") {
      if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        getTopAgent = () => TopAgentfetchData(url + "user-postex-top-agents");
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        getTopAgent = () => TopAgentfetchData(url + "user-leopard-top-agents");
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        getTopAgent = () => TopAgentfetchData(url + "user-tcs-top-agents");
      } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
        getTopAgent = () =>
          TopAgentfetchData(url + "user-travel-channel-topAgent");
      } else {
        getTopAgent = () => TopAgentfetchData(url + "user_vpbx_top_agent");
      }
    }

    // Search handle click function
    const searchhandleClick = () => {
      setLoader(true);
      if (getTopAgent) {
        getTopAgent();
      }
    };

    // Add useEffect to call the API functions when component mounts
    useEffect(() => {
      // Check if user has permission to access this page
      if (auth.role === "3") {
        if (!checkPermissions("dashboard")) {
          window.location.href = "/";
        }
      }
      
      // Get extensions list
      getExtensions();
      
      // Call API functions
      if (getTopAgent) {
        getTopAgent();
      }
    }, [auth.role, auth.vpbx_id]);

    return (
        <div className="dashboardWrp">
            <div className="uk-container uk-container-large">
                <div className="dashboardTop">
                    <div uk-grid="" className="uk-grid uk-grid-small">
                        <div className="uk-width-1-1">
                        <div className="dashboardTop">
                          <div uk-grid="" className="uk-grid uk-grid-small">
                            <div className="uk-width-1-2">
                              <div className="dashboardIntro">
                                <h3>
                                  TOP AGENTS{" "}
                                </h3>
                                <h4></h4>
                              </div>
                            </div>

                            <div className="uk-width-1-2">
                              <div className=" uk-text-right">
                                {isSearched === false ? (
                                  (auth.role === "2" ||
                                    checkIndividualPermission(
                                      "dashboard",
                                      "read_and_write"
                                    )) && (
                                    <button
                                      className="exportData-button"
                                      onClick={() => setIsSearched(true)}
                                    >
                                      Add Filter
                                    </button>
                                  )
                                ) : (
                                  <button
                                    className="exportData-button"
                                    onClick={() => setIsSearched(false)}
                                  >
                                    Close Filter
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                          
                          {isSearched === true && (
                            <div className="uk-flex uk-flex-between uk-margin-top">
                              <div>
                                <div className="dashboardIntro">
                                  <h3>
                                    <span className="companyName">Filter</span>
                                  </h3>
                                </div>
                              </div>
                              <div>
                                <div className="uk-flex uk-flex-between">
                                  <div className="uk-flex uk-flex-between">
                                    <div style={{ margin: "10px" }}>
                                      <label>Start Date</label>
                                    </div>
                                    <div>
                                      <input
                                        type="date"
                                        className="uk-input"
                                        onChange={(e) => {
                                          let date = e.target.value;
                                          setSTARTDATE(moment(date).format("YYYY-MM-DD"));
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="uk-flex uk-flex-between">
                                    <div style={{ margin: "10px" }}>
                                      <label> End Date </label>
                                    </div>
                                    <div>
                                      <input
                                        type="date"
                                        className="uk-input"
                                        onChange={(e) => {
                                          let date = e.target.value;
                                          setENDDATE(moment(date).format("YYYY-MM-DD"));
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="uk-flex uk-flex-between">
                                    <div style={{ margin: "10px" }}>
                                      <label> Extension </label>
                                    </div>
                                    <div>
                                      <select
                                        name="type"
                                        onChange={(e) => {
                                          setExtensionNumber(e.target.value);
                                        }}
                                        className="uk-select"
                                      >
                                        <option value="" selected disabled>
                                          please select Extension type
                                        </option>
                                        {extensionList?.map((val, index) => {
                                          return (
                                            <option key={index} value={val}>
                                              {val}
                                            </option>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </div>
                                  <div>
                                    <button
                                      className="exportData-button"
                                      onClick={searchhandleClick}
                                    >
                                      {loader ? (
                                        <div uk-spinner="" className="loader">
                                          {/* Searching  */}
                                        </div>
                                      ) : (
                                        "Search"
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        </div>
                    </div>
                </div>

                <div
                  uk-grid=""
                  uk-height-match="target: div > .uk-card"
                  className="uk-grid uk-grid-small"
                >
                <div className="uk-width-1-2">
                    <div className="uk-card uk-card-default uk-card-small uk-card-body">
                      <div className="head">
                        <h5 className="uk-heading-divider">Incoming top agents</h5>
                      </div>
                      <div className="AgentTable">
                        <table className="uk-table uk-table-striped">
                          <thead>
                            <tr>
                              <th>AGENT</th>
                              <th className="uk-width-small">CALLS</th>
                            </tr>
                          </thead>
                          <tbody>
                            {topAgent.inbound === null ? (
                              <tr>
                                <td>
                                  <div uk-spinner="" className="loader"></div>
                                </td>
                                <td>
                                  <div uk-spinner="" className="loader"></div>
                                </td>
                              </tr>
                            ) : (
                              topAgent.inbound
                                .sort((a, b) => b.inbound_count - a.inbound_count)
                                .map((val, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <img
                                          className="uk-preserve-width uk-border-circle"
                                          src="./assets/images/zong/newavatr.png"
                                          width="24"
                                          height="24"
                                          alt=""
                                        />
                                        <span style={{ color: "#e40077" }}>
                                          {val.extension_name === null
                                            ? val.name
                                            : val.extension_name}
                                        </span>
                                      </td>
                                      <td>{val.inbound_count}</td>
                                    </tr>
                                  );
                                })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Outgoing top agents */}
                  <div className="uk-width-1-2">
                    <div className="uk-card uk-card-default uk-card-small uk-card-body">
                      <div className="head">
                        <h5 className="uk-heading-divider">Outgoing top agents</h5>
                      </div>
                      <div className="AgentTable">
                        <table className="uk-table uk-table-striped">
                          <thead>
                            <tr>
                              <th>AGENT</th>
                              <th className="uk-width-small">CALLS</th>
                            </tr>
                          </thead>
                          <tbody>
                            {topAgent.outbound === null ? (
                              <tr>
                                <td>
                                  <div uk-spinner="" className="loader"></div>
                                </td>
                                <td>
                                  <div uk-spinner="" className="loader"></div>
                                </td>
                              </tr>
                            ) : (
                              topAgent.outbound
                                .sort((a, b) => b.outbound_count - a.outbound_count)
                                .map((val, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <img
                                          className="uk-preserve-width uk-border-circle"
                                          src="./assets/images/zong/newavatr.png"
                                          width="24"
                                          height="24"
                                          alt=""
                                        />
                                        <span style={{ color: "#e40077" }}>
                                          {val.extension_name === null
                                            ? val.name
                                            : val.extension_name}
                                        </span>
                                      </td>
                                      <td>{val.outbound_count}</td>
                                    </tr>
                                  );
                                })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    );
}

export default TopAgents